
import React from 'react'
import Navbar from '../../components/navbar/Navbar'
import PrivacySection from './components/PrivacySection'

const Privacy = () => {
  return (
    <div>
      <Navbar/>
      <PrivacySection/>
    
    </div>
  )
}

export default Privacy
